/**
 * Get In Touch Component
 * 
 * Compact CTA section between Services and Values on homepage.
 * Lighter variant of CTASection for mid-page placement.
 * 
 * @component
 */

import { memo } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const GetInTouch = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section 
      className="py-16 bg-background" 
      ref={ref}
      aria-labelledby="get-in-touch-heading"
    >
      <div className="container mx-auto px-6">
        <div 
          className={`max-w-3xl mx-auto transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <h2 
            id="get-in-touch-heading" 
            className="text-2xl md:text-3xl font-medium text-foreground mb-4 font-newsreader text-center"
          >
            Ready to optimize your logistics?
          </h2>
          <p className="text-muted-foreground mb-6 max-w-xl mx-auto text-center">
            Let's discuss how our 25+ years of maritime expertise can support your shipping needs.
          </p>
          <div className="text-center">
            <Button asChild size="lg" className="group">
              <Link to="/contact">
                Get in Touch
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(GetInTouch);
